import(/* webpackMode: "eager" */ "/app/fe/src/app/global-error.tsx");
